/**
 * The query parameters Hamla's outbound links carry, as the browser reads them.
 *
 * Must equal `TRACKING_PARAMS` in @hamla/shared, which is what the SERVER
 * writes onto every email, SMS, WhatsApp and push link. Two spellings would
 * fail silently and completely: the click would still land, the page would
 * still work, and the campaign that produced it would simply never be
 * recognised.
 *
 * Deliberately literals, not an import — the same trade-off `visitor-id.ts`
 * documents. Importing the shared constant pulls the whole package into the
 * browser bundles; it took the 1KB early beacon to 506KB. A test asserts the
 * two sets match instead: same protection, no bundle cost.
 */
export const TRACKING_PARAM = {
  VISITOR_ID: 'hamla_vid',
  CAMPAIGN_ID: 'hamla_cid',
  CHANNEL_ID: 'hamla_chid',
  DECISION_ID: 'hamla_did',
  CHANNEL_TYPE: 'hamla_ch',
  CONTACT_TOKEN: 'hamla_ct',
} as const;

/**
 * The ad click ids a landing URL can carry. Must equal `CLICK_ID_KEYS` in
 * @hamla/shared, which is what the server classifies; a test compares the two,
 * for the same bundle-size reason as `TRACKING_PARAM` above.
 *
 * The browser reads them for one thing only: a click id on the URL means the
 * visitor has just arrived from an ad, which starts a new session.
 */
export const CLICK_ID_PARAMS = [
  'gclid',
  'gbraid',
  'wbraid',
  'msclkid',
  'fbclid',
  'ttclid',
  'twclid',
  'sccid',
  'igshid',
  'li_fat_id',
] as const;
